
import { WPPageData } from '@/types'

export const pageHasHero = (pageProps: WPPageData) => {
  const firstSection = pageProps?.acf?.builder?.[0]
  const layout =
    firstSection && typeof firstSection.acf_fc_layout === 'string'
      ? firstSection.acf_fc_layout
      : ''
  const acfWithHero = layout.includes('hero')

  if (!acfWithHero) return false

  return Boolean(
    firstSection?.media?.poster?.url && firstSection?.type !== '2_col'
  )
}
